"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Embed = function (_a) {
    var attributes = _a.attributes, embedUrl = _a.embedUrl, width = _a.width, isPrintMode = _a.isPrintMode;
    if (!embedUrl) {
        return null;
    }
    if (isPrintMode) {
        return printEmbedWidgetPlaceholder(width);
    }
    return (react_1.default.createElement("div", { className: "iframe-widget" },
        react_1.default.createElement("figure", null,
            react_1.default.createElement("div", { style: attributes.style, className: (0, classnames_1.default)(attributes.className, "embed-widget__container") },
                react_1.default.createElement("div", { className: "embed-widget__iframe-container" },
                    react_1.default.createElement("iframe", { src: embedUrl, title: "Video", frameBorder: "0", allowFullScreen: true, className: "embed-widget__iframe" }))))));
};
var printEmbedWidgetPlaceholder = function (width) {
    var wrapperWidth = 100;
    var wrapperPaddingBottom = 55;
    var fontSizePx = 15;
    var iconWidthPx = 50;
    var marginBottomPx = 15;
    if (width && typeof width === "number") {
        fontSizePx *= width / 100;
        iconWidthPx *= width / 100;
        marginBottomPx *= width / 100;
        wrapperWidth *= width / 100;
        wrapperPaddingBottom *= width / 100;
    }
    var wrapperStyle = "width: ".concat(wrapperWidth, "%; height: 0; padding-bottom: ").concat(wrapperPaddingBottom, "%;");
    return (react_1.default.createElement("div", { className: "embedded-content", dangerouslySetInnerHTML: {
            __html: "<div class=\"print-placeholder avoid-page-break\" style=\"".concat(wrapperStyle, "\">\n          <div class=\"print-background\">\n            <img class=\"cloud\" src=\"/Public/Assets/Images/cloud-bg.svg\"/>\n          </div>\n          <div class=\"print-message\">\n            <img\n              class=\"offline-icon\"\n              src=\"/Public/Assets/icons/offline-grey.svg\"\n              style=\"width: ").concat(iconWidthPx, "px; margin-bottom: ").concat(marginBottomPx, "px;\"\n            />\n            <div class=\"description\" style=\"font-size: ").concat(fontSizePx, "px;\">Iframe content can't be viewed offline</div>\n          </div>\n        </div>"),
        } }));
};
exports.default = Embed;
